import { Search } from "lucide-react";
import { useRef, useState } from "react";
import { useJournalFilterContext } from "@/contexts/JournalFilterContext";
import { cn } from "@/lib/utils";
import { useTranslate } from "@/utils/i18n";
import JournalDisplaySettingMenu from "./JournalDisplaySettingMenu";

const SearchBar = () => {
  const t = useTranslate();
  const { addFilter } = useJournalFilterContext();
  const [queryText, setQueryText] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const onTextChange = (event: React.FormEvent<HTMLInputElement>) => {
    setQueryText(event.currentTarget.value);
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const trimmedText = queryText.trim();
      if (trimmedText !== "") {
        const words = trimmedText.split(/\s+/);
        words.forEach((word) => {
          addFilter({
            factor: "contentSearch",
            value: word,
          });
        });
        setQueryText("");
      }
    }
  };

  return (
    <div className="relative w-full h-auto flex flex-row justify-start items-center">
      <Search className="absolute left-3 w-4 h-auto text-muted-foreground" />
      <input
        className={cn(
          "w-full text-foreground leading-6",
          "glass-card rounded-xl p-2.5 pl-10 outline-0",
          "text-sm placeholder:text-muted-foreground",
          "focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500/30 transition-all duration-200",
          "border border-border hover:border-purple-500/20",
        )}
        placeholder={t("memo.search-placeholder")}
        value={queryText}
        onChange={onTextChange}
        onKeyDown={onKeyDown}
        ref={inputRef}
      />
      <JournalDisplaySettingMenu className="absolute right-3 top-2.5 text-muted-foreground hover:text-primary transition-colors" />
    </div>
  );
};

export default SearchBar;
